@if(isBrowser()) {
@if(!isDisabled()) {
<div class="sel-wrapper">
    @for (fl of list(); track $index) {
    <div class="selected-item">
        <span>{{fl.name}}</span>
        <button (click)="this[fl.function](fl.index)">
            <mat-icon class="clearbtn">clear</mat-icon>
        </button>
    </div>
    }
    @if(list()?.length > 0) {
        <button class="all-remove" (click)="resetAll()">{{'Alle Filter löschen'}}</button>
    }
</div>
}
}